module.exports = __webpack_public_path__ + "lp/img/next.3be19e59.svg";